import http from "@/shared/axios-config/g-http-metodos";

function GetDocumentoComissaoByFiltro(objFiltro){
  const { res, erro, requisicao } = http.postArray("DocumentoComissao/GetDocumentoComissaoByFiltro", objFiltro)
  return { DocumentoComissoesArray: res, erro, requisicao }
}

function GetDocumentoComissaoTipoEnum(){
  const { res, erro, requisicao } = http.getArray("DocumentoComissao/GetTipoEnum")
  return {  res, erro, requisicao }
}

const DocumentoComissaoController = {
  GetDocumentoComissaoByFiltro,
  GetDocumentoComissaoTipoEnum,
}

export default DocumentoComissaoController;
